import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Live site-wide promotion for a channel ("online" | "pos"), refreshed every 60s. */
export function useActivePromotion(channel = "online") {
  const [promo, setPromo] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/promotions/active", { params: { channel } }).then((r) => alive && setPromo(r.data.promotion)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [channel]);
  return promo;
}

/** Cents-exact promo discount — must match `promo_cents` on the backend. */
export const promoDiscount = (subtotal, promo) => {
  if (!promo || subtotal <= 0) return 0;
  const cents = Math.round(subtotal * 100);
  return Math.min(cents, Math.floor((cents * Number(promo.percent)) / 100 + 0.5)) / 100;
};
